import { makeStyles } from '@material-ui/core/styles'
import NotesIcon from '@mui/icons-material/Notes'
import GroupsIcon from '@mui/icons-material/Groups'
import moment from 'moment'

import { Box, Grid, Divider, Link } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.error.main,
  },

  card: {
    padding: '0 0.8rem',
  },
  cardContent: {
    padding: '0.2em 0.6rem 0',
  },
  cardDate: {
    fontWeight: 'bold',
    fontSize: '0.9em',
    margin: '0.5em 0 0',
  },
  cardDivider: {
    height: '4em',
    width: '2px',
    position: 'relative',
    left: '0.5em',
    backgroundColor: '#5D5D5D88',
  },
}))
const EventIcon = (props) => {
  const { eventType } = props
  if (eventType === 'ticket') {
    return (
      <NotesIcon
        sx={{
          fontSize: 20,
          margin: '.6em 0 0',
        }}
      />
    )
  }
  if (eventType === 'ag') {
    return <GroupsIcon sx={{ fontSize: 20, margin: '.6em 0 0' }} />
  } else {
    return <NotesIcon sx={{ fontSize: 20, margin: '.6em 0 0' }} />
  }
}

export const Events = (event, ...props) => {
  event = event.event
  const classes = useStyles()
  return (
    <>
      <Box className={classes.card}>
        <Grid container>
          <Grid alignItems="center" item xs={1}>
            <div>
              <EventIcon eventType={event.type} />
              <Divider
                className={classes.cardDivider}
                orientation="vertical"
                flexItem
              />
            </div>
          </Grid>
          <Grid item xs={11}>
            <Box className={classes.cardContent}>
              <div className={classes.cardDate}>{`${moment(event.date).format(
                'DD/MM/YYYY, hh:mm'
              )}`}</div>
              <Link
                href={
                  event.type === 'ticket' &&
                  `/tickets?filter={"q":"${event.id}"}`
                }
              >
                {event.title}
              </Link>

              <p>{event.description}</p>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
